var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEvenOut = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.75A.75.75 0 0 1 12.75 3.75V7.19L14.22 5.72A.75.75 0 1 1 15.28 6.78L12.53 9.53A.75.75 0 0 1 11.47 9.53L8.72 6.78A.75.75 0 1 1 9.78 5.72L11.25 7.19Z",
    fill: "#494C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 11.25H19.25A.75.75 0 0 1 19.25 12.75H4.75A.75.75 0 0 1 4.75 11.25Z",
    fill: "#494C5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20.25A.75.75 0 0 0 12.75 20.25V16.81L14.22 18.28A.75.75 0 1 0 15.28 17.22L12.53 14.47A.75.75 0 0 0 11.47 14.47L8.72 17.22A.75.75 0 1 0 9.78 18.28L11.25 16.81Z",
    fill: "#494C5B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEvenOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/evenOut.2360dcaf4a0040a292336a22e0e5af74.svg";